// Third party dependencies
import { Box, Heading, MainArea, Page } from '@salecycle/ui-component-library';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

// Local dependencies
import { ClientLevel } from 'core/types';
import AppTopBar from 'core/ui/components/AppTopBar/AppTopBar';
import { FileExportClientSelectionArea, FileExportTable } from '../components';

export const FileExportPage = () => {
  const location = useLocation<{ clientId: string; clientLevel: ClientLevel }>();
  const { t } = useTranslation('fileExport');
  const [clientId, setClientId] = useState(location.state?.clientId ?? null);
  const [clientLevel, setClientLevel] = useState(location.state?.clientLevel ?? ClientLevel.SITE);

  const onLevelChanged = level => {
    setClientLevel(level);
    setClientId(clientLevel === level ? clientId : null);
  };

  return (
    <MainArea>
      <AppTopBar />
      <Page>
        <Box stackItems={true}>
          <Heading>{t('title')}</Heading>
          <FileExportClientSelectionArea
            onClientChange={setClientId}
            clientId={clientId}
            clientLevel={clientLevel}
            onLevelChanged={onLevelChanged}
          />
          {clientId && <FileExportTable clientLevel={clientLevel} clientId={clientId} />}
        </Box>
      </Page>
    </MainArea>
  );
};
